export default __webpack_public_path__ + "static/media/paraf_logo.f74bec21.png";